const tableTitlePlaces = {
  title: 'Locations',
  placeholder: 'Search'
};

export default tableTitlePlaces;
